export default "__VITE_ASSET__D0HI$gYv__"